module.exports = __webpack_public_path__ + "img/carlos-bravo.dd827223.png";